/** @jsx jsx */

import React, { useState, useEffect, useCallback } from "react";
import { Steps, Typography } from "antd";
import { jsx } from "@emotion/core";

import useRedirect from "../../helperHooks/useRedirect";
import useLoanStatus from "../../hooks/auth/useLoanStatus";

import { eligibilityTopStepsStyles } from "./EligibilityViewStyles";
import { EligibilityViewConstants as CONSTANTS } from "./EligibilityViewConstants";
import activeDot from "../../assets/top-steps-active-dot.svg";
import inactiveDot from "../../assets/top-steps-dot.svg";

const { Step } = Steps;
const { Text } = Typography;

interface EligibilityViewStepsProps {
  fold: string;
  foldIndex: number;
}

const EligibilityViewSteps: React.FC<EligibilityViewStepsProps> = ({
  fold,
  foldIndex
}: EligibilityViewStepsProps) => {
  const { disableAccountDetailsPage, disableKycPage } = useLoanStatus();
  const getCurrentStep = useCallback(
    () =>
      foldIndex !== -1
        ? 0
        : fold === CONSTANTS.labels.topbarSteps[1].fold
        ? 1
        : 2,
    [fold, foldIndex]
  );

  const [currentStep, setCurrentStep] = useState<number>(getCurrentStep());
  const redirect = useRedirect();

  useEffect(() => {
    setCurrentStep(getCurrentStep());
  }, [getCurrentStep]);

  const handleChange = (clickedStep: number) => {
    redirect(CONSTANTS.labels.topbarSteps[clickedStep].route);
  };

  const isStepDisabled = (stepTitle: string) => {
    if (stepTitle === CONSTANTS.labels.topbarSteps[1].stepTitle) {
      return disableAccountDetailsPage;
    } else if (stepTitle === CONSTANTS.labels.topbarSteps[2].stepTitle) {
      return disableKycPage;
    }
    return false;
  };

  return (
    <Steps
      css={eligibilityTopStepsStyles}
      className="pt-0 pb-5"
      size="small"
      onChange={handleChange}
      current={currentStep}
    >
      {CONSTANTS.labels.topbarSteps.map(({ stepTitle }, i) => (
        <Step
          key={stepTitle}
          title={
            <Text
              className={`${
                currentStep === i ? "active-step-title" : "inactive-step-title"
              }`}
            >
              {stepTitle}
            </Text>
          }
          icon={
            <img src={currentStep === i ? activeDot : inactiveDot} alt="Dot" />
          }
          disabled={isStepDisabled(stepTitle)}
        />
      ))}
    </Steps>
  );
};

export default EligibilityViewSteps;
